import { render, staticRenderFns } from "./passport_info.vue?vue&type=template&id=5980d550&"
import script from "./passport_info.vue?vue&type=script&lang=js&"
export * from "./passport_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports